import { render, staticRenderFns } from "./AboutFour.vue?vue&type=template&id=c08e8852&scoped=true"
import script from "./AboutFour.vue?vue&type=script&lang=js"
export * from "./AboutFour.vue?vue&type=script&lang=js"
import style0 from "./AboutFour.vue?vue&type=style&index=0&id=c08e8852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08e8852",
  null
  
)

export default component.exports